module.exports = __webpack_public_path__ + "img/conteudos_casas_construcao_18.e80c122c.png";